import React from 'react';
import {connect} from 'react-redux';

class DynamicText extends React.Component {
    static defaultProps = {
        lineHeight: 1,
        capHeight: 0.71
    };

    constructor(props) {
        super(props);
        this.state = {
            lines: [],
            selectedpremarket: ''
        };

        this.OnMarketClick = this.OnMarketClick.bind(this);
    }

    componentDidMount() {

        this.displayMarkets();

    }

    componentDidUpdate(nextProps, nextState) {
        if (this.props.markets !== nextProps.markets) {
            this.displayMarkets();
        }
    }

    displayMarkets() {
        if (this.props.markets) {
            const {citiesWithComputedWidth, spaceWidth} = this.calculateCityWidths(this.props.markets, true);
            this.citiesWithComputedWidth = citiesWithComputedWidth;
            this.spaceWidth = spaceWidth;
        }

        let lines = [];

        if (this.citiesWithComputedWidth !== undefined) {
            lines = this.calculateLines(this.citiesWithComputedWidth, this.spaceWidth, this.props.width);
        }

        const newLineAdded = this.state.lines.length !== lines.length;
        let cityMoved = false;
        if (lines.length >= this.state.lines.length) {
            cityMoved = this.state.lines.some((line, index) => line.length !== lines[index].length || line !== lines[index])
        }
        // -10 for positions t give a 10px distance from the spoke 13.1764705
        if (this.props.markets) {
            if (this.props.position === "6") {
                if (lines.length > 2) {
                    const magic_6 = (330 - (lines.length - 1.5) * 13.5);
                    this.props.onChangeLink6(60, magic_6);
                } else
                    this.props.onChangeLink6(55, 275);
            }
            if (this.props.position === "5") {
                this.props.onChangeLink5(66, 620);
            }
            if (this.props.position === "4") {
                if (lines.length > 3) {
                    const magic_4 = (840 - (lines.length - 1.5) * 13.5);
                    this.props.onChangeLink4(510, magic_4);
                } else
                    this.props.onChangeLink4(510, 800);
            }
            if (this.props.position === "3") {
                if (lines.length > 3) {
                    const magic_3 = (610 - (lines.length - 1.5) * 13.5);
                    this.props.onChangeLink3(860, magic_3);
                } else
                    this.props.onChangeLink3(860, 600);
            }
            if (this.props.position === "2") {
                if (lines.length > 3) {
                    const magic_2 = (345 - (lines.length - 1.5) * 13.5);
                    this.props.onChangeLink2(840, magic_2);
                } else
                    this.props.onChangeLink2(840, 300);
            }
            if (this.props.position === "1") {
                if (lines.length > 1) 
                {
                    const magic_1 = (96 - (lines.length - 1.5) * 13.5) - 7;
                    this.props.onChangeLink1(460, magic_1);
                }else
                this.props.onChangeLink1(460, 100);
            }
        }

        // Only update if number of lines or length of any lines change
        if (newLineAdded || cityMoved) {
            this.setState({lines})
        }

    };

    getTextWidth(text) {
        let canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement("canvas"));
        let context = canvas.getContext("2d");
        context.font = "15px Calibre";
        let metrics = context.measureText(text);
        return metrics.width;
    };

    //async
    OnMarketClick(e) {

        e.stopPropagation();

        this.props.marketClicked(e.target.id, document.getElementById('Position-' + this.props.position + '-markets').getAttribute("fill"), this.props.position);

    };

    calculateCityWidths(citiesArray, needsSort) {
        // Calculate length of each city to be used to determine number of cities per line
        let cities = citiesArray.split(/\|+/);

        if (needsSort) {
            cities = cities.sort();
        }

        const citiesWithComputedWidth = cities.map(city => {

            return {city, width: this.getTextWidth(city)}
        });


        const spaceWidth = 10;
        const pipeWidth = 20;

        return {citiesWithComputedWidth, spaceWidth, pipeWidth}
    };

    calculateLines(citiesWithComputedWidth, spaceWidth, lineWidth) {
        const citiesByLines = citiesWithComputedWidth.reduce((result, {city, width}) => {
            const lastLine = result[result.length - 1] || {cities: [], width: 0};

            if (lastLine.cities.length === 0) {
                // First city on line
                const newLine = {cities: [city], width};
                result.push(newLine);
            } else if (lastLine.width + width + (lastLine.cities.length * spaceWidth) < lineWidth - 50) {
                // City can be added to an existing line
                lastLine.cities.push(city);
                lastLine.width += width;
            } else {
                // City too long to fit on existing line
                const newLine = {cities: [city], width};
                result.push(newLine);
            }

            return result;
        }, []);

        return citiesByLines.map(line => line.cities.join(' | '));
    };

    calculateTotalLineWidths(cityArray) {
        const cities = cityArray;

        let citiesWithComputedWidth = {cities, width: this.getTextWidth(cities)};

        return {citiesWithComputedWidth};
    };


    splitSpan = (city, index, x, y, lineHeight, position, dy) => {
        const citiesArray = city.split("|");

        const {citiesWithComputedWidth, pipeWidth} = this.calculateCityWidths(city, false);
        const items = [];
        let space = 0;
        let preSpace = 0;
        let pipe = "|";
        let xspace = 0;
        let citylinelength = 0;


        if (position === '8' || position === '7' || position === '6') {
            citylinelength = this.calculateTotalLineWidths(city);
            xspace = (175 - citylinelength.citiesWithComputedWidth.width);

            if (citiesWithComputedWidth.length > 2) {
                xspace = xspace - 6;
            }

        }
        if (position === '9' || position === '1' || position === '5') {
            citylinelength = this.calculateTotalLineWidths(city);
            xspace = (175 - citylinelength.citiesWithComputedWidth.width) / 2;
        }
        if (position === '4' || position === '3' || position === '2') {
            xspace = 0;
        }

        for (const [key, value] of citiesWithComputedWidth.entries()) {

            if (key === 0) {
                space = 0;
                preSpace = value.width;

                if (citiesArray.length === 1 && (position === '6' || position === '7' || position === '8')) {
                    // items.push(<svg dy={`${dy}em`} height="auto" x={space + xspace + 5} y={-1 * y} fill="none"><rect x={space + xspace + 10} y={-1 * y} dy={`${index * lineHeight}em`} height="20" width={this.getTextWidth(value.city)} fill="#CAD1D3" rx="5"/></svg>);
                    items.push(<svg key={`svg-${value.city}`} >
                                <rect  transform="translate(15, 0)"x={space + xspace + 5} y={`${index * 1.75 * lineHeight + 0.25}em`} dy={y} height="20" width={this.getTextWidth(value.city) + 10} rx="10" 
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-at-spoke-background-selected" : "cursor-pointer market-at-spoke-background"}`} />
                                <text dy={`${dy}em`} height="auto">
                                    <tspan rentcycledata-auto='marketname' id={value.city} 
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-selected-bold" : "cursor-pointer markets-at-spoke-level"}`} 
                                    onClick={this.OnMarketClick} key={value.city} x={space + xspace + 15 +10} y={y} dy={`${index * 1.75*lineHeight + 0.5}em`}>{value.city}</tspan>
                                </text></svg>);
                } else {
                    // items.push(<svg dy={`${dy}em`} height="auto" x={space + xspace + 5} y={-y}  fill="none"><rect x={space + xspace + 5} y={-y} dy={`${index * lineHeight}em`} height="20" width={this.getTextWidth(value.city)} fill="#CAD1D3" rx="5"/></svg>);
                    items.push(<svg key={`svg-${value.city}`}>
                                <rect transform="translate(15, 0)" x={space + xspace} y={`${index * 1.75 *lineHeight + 0.25}em`} dy={y} height="20" width={this.getTextWidth(value.city) + 10} rx="10"
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-at-spoke-background-selected" : "cursor-pointer market-at-spoke-background"}`} />
                                <text dy={`${dy}em`} height="auto">
                                    <tspan rentcycledata-auto='marketname' id={value.city} 
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-selected-bold" : "cursor-pointer markets-at-spoke-level"}`}
                                    onClick={this.OnMarketClick} key={value.city} x={space + xspace + 10 +10} y={y} dy={`${index * 1.75* lineHeight + 0.5}em`}>{value.city}</tspan>
                                </text></svg>);
                }
            } else {
                space = (preSpace + pipeWidth);
                preSpace = preSpace + value.width + pipeWidth;
                // items.push(<svg dy={`${dy}em`} height="auto" x={space + xspace + 5} y={-y}  fill="none"><rect x={space + xspace + 5} y={-y} dy={`${index * lineHeight}em`} height="20" width={this.getTextWidth(value.city)} fill="#CAD1D3" rx="5"/></svg>);
                items.push(<svg key={`svg-${value.city}`} >
                                <rect  transform="translate(15, 0)" x={space + xspace} y={`${index * 1.75 *lineHeight + 0.25}em`} dy={y} height="20" width={this.getTextWidth(value.city) + 10} rx="10"
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-at-spoke-background-selected" : "cursor-pointer market-at-spoke-background"}`} />
                                <text dy={`${dy}em`} height="auto">
                                    <tspan rentcycledata-auto='marketname' id={value.city} 
                                    className={`${this.props.marketSelected.trim() === value.city.trim() ? "cursor-pointer market-selected-bold" : "cursor-pointer markets-at-spoke-level"}`}
                                    onClick={this.OnMarketClick} key={value.city} x={space + xspace + 10 +10} y={y} dy={`${index * 1.75* lineHeight + 0.5}em`}>{value.city}</tspan>
                                </text></svg>);
            }

            // if (citiesWithComputedWidth.length > 1 && key !== citiesWithComputedWidth.length - 1) {       
            //     // items.push(<svg dy={`${dy}em`} height="auto" x={space + xspace + 5} y={-y} fill="none"><rect x={preSpace + 15 + xspace} y={-y} dy={`${-index * lineHeight}em`} height="20" width={this.getTextWidth(value.city)} fill="#CAD1D3" rx="5"/></svg>);         
            //     items.push(<svg >
            //                     <rect x={preSpace + 15 + xspace} y={`${index * lineHeight}em`} dy={`${index * lineHeight}em`} height="20" width={this.getTextWidth(value.city) + 5} fill="#CAD1D3" rx="10"/>
            //                     <text dy={`${dy}em`} height="auto" >
            //                         <tspan key={value.city } x={preSpace + 15 + xspace} y={y} dy={`${index * lineHeight}em`}>{}</tspan>
            //                     </text></svg>);
            // }

        }
        return (items);

    };


    render() {
        
        // determine lineHeight and dy dynamically (using passed in props)
        const {lineHeight, capHeight, onChangeLink, onChangeLink1, onChangeLink2, onChangeLink3, onChangeLink4, onChangeLink5, onChangeLink6, onChangeLink7, onChangeLink8, marketClicked, ...props} = this.props;
        const dy = capHeight;
        const {x, y, position} = props;

        return (
            <svg dy={`${dy}em`} height="auto" >
                {this.state.lines.map((city, index) => (
                    this.splitSpan(city, index, x, y, lineHeight, position,dy)
                ))}
            </svg>
        )
    }

}

//export default DynamicText;
const mapStateToProps = (state) => {
    return {
        marketSelected: state.marketselected
    };
};


export default connect(mapStateToProps)(DynamicText);

